// @flow

import { vec2 } from 'gl-matrix/dist/gl-matrix-min.js'

import type THREE from 'three'

type PosType = {
  z: number,
  y: number
}

export default class CameraApp {
  camera: THREE.Camera
  scene: THREE.Scene
  goal: vec2
  cameraPos: vec2
  ratio: number
  automatic: boolean
  direction: 1 | -1 /* 1 --> forward | -1 --> backward */
  planeHeight: number
  updateCamera: (pos: PosType) => void

  constructor(camera: THREE.Camera, scene: THREE.Scene, goal: Array<number>, updateCamera: (pos: PosType) => void) {
    this.camera = camera
    this.scene = scene
    this.goal = vec2.fromValues(goal[0], goal[1])
    this.cameraPos = vec2.fromValues(camera.position.z, camera.position.y)
    this.updateCamera = updateCamera
    this.ratio = 16/10
    this.direction = 1
    this.automatic = false
    this.planeHeight = 0
  }

  updatePos () {
    const dir = vec2.fromValues(0, 0)
    vec2.subtract(dir, this.goal, this.cameraPos)
    vec2.scale(dir, dir, this.ratio / 50)
    vec2.add(this.cameraPos, dir, this.cameraPos)
    this.updateCamera({z: this.cameraPos[0], y: this.cameraPos[1]})
    if (this.automatic) this.updateGoal({z: (this.ratio / 5) * this.direction, y: 0})
  }

  updateGoal (pos: PosType) {
    const newValues = vec2.fromValues(-pos.z, pos.y)
    vec2.add(this.goal, newValues, this.goal)
  }

  setUpdateGoal (pos: PosType) {
    this.goal = vec2.fromValues(pos.z, pos.y)
  }

  setAutomatic (automatic: boolean) { this.automatic = automatic }

  setDirection (direction: 1 | -1) { this.direction = direction }

  setPlaneHeight (height: number) { this.planeHeight = height }

  getPlaneHeight (): number { return this.planeHeight }

}


// WEBPACK FOOTER //
// ./src/utils/cameraApp.js